import { Journey } from '@audibene/ta.utils-opportunity'
import { useIsFetching, useQuery } from 'react-query'
import { ResourceType } from '../../../../constants'
import { useAppointmentLocationState } from '../../../../hooks'
import { useAppointmentsService } from '../../../../hooks/services'
import { QueryOptions } from '../../../../types'
import { logFactory } from '../../../../util'
import { useIsConfigurationReadOnly } from '../useIsConfigurationReadOnly'

type QueryParams = Partial<{
  countries: string[]
  isActive: boolean
  journey: Journey
  resourceIds: string[]
  shopIds: string[]
  states: string[]
  types: ResourceType[]
}>

const hookName = 'useResources'
const log = logFactory(hookName)

const useResources = (params: QueryParams, options: QueryOptions = { enabled: true }) => {
  const { getResources, isReady } = useAppointmentsService()
  const isConfigurationReadOnly = useIsConfigurationReadOnly()
  const { resource_ids } = useAppointmentLocationState()
  const { countries, isActive = true, journey, resourceIds, shopIds, states, types } = params

  // In the case of cancellation/rescheduling we lock to a specific resource
  const actualResourceIds = isConfigurationReadOnly && resource_ids?.length ? resource_ids : resourceIds

  const doQuery = async () => {
    log(`🙉 Getting resources...`, params)

    const data = await getResources({
      country: countries,
      id: actualResourceIds,
      journey,
      shop_id: shopIds,
      state: states,
      type: types,
      is_active: isActive,
    })

    log(`🙉 Found resources`, data)

    return data
  }

  const isQueryEnabled = isReady && options.enabled

  return useQuery([hookName, params], doQuery, { ...options, enabled: isQueryEnabled })
}

const useAreResourcesFetching = () => Boolean(useIsFetching([hookName]))

export { useAreResourcesFetching, useResources }
